import { IApplicationState, TCardId } from '../../../../../../../../types/types';
import { getCustomProperties } from '../../selectors/getCustomProperties';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ECustomPropertyType } from '../../../../../../../../store/customProperties/types';

export const getDisabledActions = (
    state: IApplicationState,
    cardId: TCardId,
)=> {
    const res: string[] = [];
    getCustomProperties(state, getBoardIdByCardId(state, cardId), cardId)
        .forEach(property => {
            if (property.type === ECustomPropertyType.DATE && !property.value) {
                res.push(String(property.id));
            }
        });
    return res;
};
